export function extend(base, extension) {
    for (var property in extension) {
        if (extension.hasOwnProperty(property)) {
            base[property] = extension[property];
        }
    }
}
//# sourceMappingURL=objects.js.map